<template>
  <multiple_form
    :forms="forms"
    :edit="props.isEdit"
    :editData="props.editData"
    :disabled="props.disabled"
    @submit="handelSubmit"
    submitText="审批"
    ref="formRef"
    :labelCol="{ span: 9 }"
  >
    <template #approval>
      <h4>审批流程</h4>
      <approval_process_content :data="approvalProcessData">
      </approval_process_content>
      <h4>审批注意事项</h4>
      <div style="color: #ff4d4f">请审批人仔细核验所审批内容的真实性、准确性与合规性，您提交"审批通过"的审批意见即视为确认内容无误，并承担相应审核责任。请秉持客观公正原则履行审批职责，共同维护流程严谨性与组织公信力。</div>
    </template>
  </multiple_form>
</template>
<script setup>
  import { defineProps, defineEmits, computed, ref } from 'vue'
  import { message } from 'ant-design-vue'
  import { approval } from '@/api/transport/transport_approval'
  import { approvalProcess } from '@/api/transport/all_transport_history'
  import multiple_form from '@/components/multiple_form'
  import { transportType, resultOptions, cityDelivery } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'
  import approval_process_content from '@/components/approval_process_content'
  //初始化
  const props = defineProps({
    isEdit: Boolean,
    editData: Object,
    idField: String,
    isBatch: { default: false },
    disabled: { type: Boolean, default: false },
  })
  const emit = defineEmits(['submit'])
  //console.log(props.editData, 'ddd')

  const formRef = ref()
  //编辑、新增的表单
  const forms = computed(() => [
    {
      name: '运单信息',
      id: 'transport',
      dataInObject: 'dangerousCargoTransportList',
      formItem: [
        {
          type: 'input',
          field: 'application_number',
          label: '运单受理单号',
        },
        {
          type: 'radio',
          field: 'transport_type',
          options: constantToOptions(transportType),
          label: '运货类型',
        },
        {
          type: 'input',
          field: 'list_number',
          label: '运单编号（国家统一运单编号）',
        },
        {
          type: 'input',
          field: 'cargo_name',
          label: '货物名称',
        },
        {
          type: 'input',
          field: 'cargo_quantity',
          label: '货物数量',
        },
        {
          type: 'input',
          field: 'cargo_unit',
          label: '货物单位（吨）',
        },
        {
          type: 'input',
          field: 'enterprise',
          label: '承运方企业名称',
        },
        {
          type: 'input',
          field: 'unified_social_credit_code',
          label: '承运方企业统一信用代码',
        },
        {
          type: 'input',
          field: 'business_license_number',
          label: '承运方企业经营许可证号',
        },
        {
          type: 'input',
          field: 'contact_phone',
          label: '承运人联系电话',
        },
        {
          type: 'input',
          field: 'contact_phone',
          label: '承运人联系电话',
        },
        {
          type: 'input',
          field: 'license_plate',
          label: '车牌号码',
        },
        {
          type: 'input',
          field: 'license_plate_color',
          label: '车辆号牌颜色',
        },
        {
          type: 'input',
          field: 'vehicle_transport_license',
          label: '车辆道路运输证号',
        },
        {
          type: 'input',
          field: 'trailer_license',
          label: '挂车号牌',
          required: false,
        },
        {
          type: 'input',
          field: 'trailer_transport_license',
          label: '挂车道路运输证号',
          required: false,
        },
        {
          type: 'input',
          field: 'tank_volume',
          label: '罐体容积(m³)',
          required: false,
        },
        /*{
          type: 'input',
          field: 'tank_number',
          label: '罐体编号',
          required: false,
        },*/
        // {
        //   type: 'input',
        //   field: 'tank_truck_dimensions',
        //   label: '槽罐车尺寸',
        // },
        {
          type: 'input',
          field: 'driver',
          label: '驾驶员姓名',
        },
        {
          type: 'input',
          field: 'driver_phone',
          label: '驾驶员联系方式',
        },
        {
          type: 'input',
          field: 'driver_qualification_certificate',
          label: '驾驶员从业资格证号',
        },
        // {
        //   type: 'input',
        //   field: 'driver_qc_validity_start',
        //   label: '驾驶员从业资格证有效开始日期',
        // },
        // {
        //   type: 'input',
        //   field: 'driver_qc_validity_end',
        //   label: '驾驶员从业资格证有效结束日期',
        // },
        {
          type: 'input',
          field: 'supercargo',
          label: '押运员姓名',
        },
        {
          type: 'input',
          field: 'supercargo_phone',
          label: '押运员联系方式',
        },
        {
          type: 'input',
          field: 'supercargo_qualification_certificate',
          label: '押运员从业资格证号',
        },
        // {
        //   type: 'input',
        //   field: 'supergo_qc_validity_start',
        //   label: '押运员从业资格证有效开始日期',
        // },
        // {
        //   type: 'input',
        //   field: 'supergo_qc_validity_end',
        //   label: '押运员从业资格证有效结束日期',
        // },
        {
          type: 'input',
          field: 'shipper',
          label: '托运人姓名',
        },
        {
          type: 'input',
          field: 'shipper_phone',
          label: '托运人联系电话',
        },
        // {
        //   type: 'input',
        //   field: 'shipper_bln',
        //   label: '托运人公司经营许可证号',
        // },
        {
          type: 'input',
          field: 'recipient',
          label: '收货人姓名',
        },
        {
          type: 'input',
          field: 'recipient_phone',
          label: '收货人联系电话',
        },
        {
          type: 'input',
          field: 'carrier',
          label: '装货人姓名',
        },
        {
          type: 'input',
          field: 'carrier_phone',
          label: '装货人联系电话',
        },
        // {
        //   type: 'input',
        //   field: 'dispatcher',
        //   label: '调度人姓名',
        // },
        // {
        //   type: 'input',
        //   field: 'dispatcher_start_time',
        //   label: '调度开始时间',
        // },
        // {
        //   type: 'input',
        //   field: 'dispatcher_end_time',
        //   label: '调度结束时间',
        // },
        {
          type: 'input',
          field: 'shipment_date',
          label: '起运日期',
        },
        {
          type: 'input',
          field: 'shipment_addr',
          // label: '起运地',
          label: props.editData.dangerousCargoTransportList.transport_type == 1 ? '起运地' : '起运地(省/市/区+详细地址)',
        },
        {
          type: 'input',
          field: 'destination',
          // label: '目的地(省/市/区+详细地址)',
          label: props.editData.dangerousCargoTransportList.transport_type == 1 ? '目的地(省/市/区+详细地址)' : '目的地',
        },
        /*{
          type: 'radio',
          field: 'city_delivery',
          options: constantToOptions(cityDelivery),
          label: '是否城市配送',
        },*/
        {
          type: 'image',
          field: 'annex',
          label: '运单附件（国家统一运单的图片）',
        },
      ],
    },
    {
      name: '审批信息',
      id: 'approval',
      formItem: [
        {
          type: 'radio',
          field: 'result',
          label: '审批结果',
          defaultValue: 1,
          options: constantToOptions(resultOptions),
          disabled: false,
          onChange: (val) => {
            if (
              formRef.value &&
              formRef.value.formRefs &&
              formRef.value.formRefs.approval &&
              formRef.value.formRefs.approval.formState
            ) {
              formRef.value.formRefs.approval.formState.remark =
                // val.target.value === '1' ? '审批通过。' : '审批不通过。'
                val.target.value === '1' ? '审批通过。' : ''
            }
          },
        },
        {
          type: 'textarea',
          field: 'remark',
          label: '审批意见',
          width: '300px',
          defaultValue: '审批通过。',
          disabled: false,
        },
      ],
    },
  ])

  async function handelSubmit(data) {
    const messageText = '审核'
    const res = await approval({
      ...data,
      taskIds: props.editData[props.idField],
    })
    
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }

  const approvalProcessData = ref()
  if (props.editData?.dangerousCargoTransportList?.id) {
    getApprovalProcess()
  }
  async function getApprovalProcess() {
    const res = await approvalProcess({ id: props.editData.dangerousCargoTransportList.id })
    approvalProcessData.value = res.data
  }
</script>
